import React from 'react';

import { Flex } from '@atlaskit/primitives';

import {
	FinalTimelineIconStyled,
	TimelineDayBody,
	TimelineDayTitle,
	TimelineIconStyled,
} from '../../styled/StyledModal';

export const Day = ({
	title,
	subtitle,
	icon,
	finalDay,
}: {
	title: JSX.Element;
	subtitle: JSX.Element;
	icon: JSX.Element;
	finalDay?: boolean;
}) => {
	return (
		<div>
			<Flex direction="row" gap="space.100" alignItems="center">
				{finalDay ? (
					<FinalTimelineIconStyled>{icon}</FinalTimelineIconStyled>
				) : (
					<TimelineIconStyled>{icon}</TimelineIconStyled>
				)}
				<Flex direction="column" gap="space.050">
					<TimelineDayTitle>{title}</TimelineDayTitle>
					<TimelineDayBody>{subtitle}</TimelineDayBody>
				</Flex>
			</Flex>
		</div>
	);
};
